<template>
  <b-modal
    :id="id"
    size="xl"
    :title="title"
    @hide="handleHide(planChanged)"
    @show="handleShow(false)"
    ok-only
    bodyClass="p-0"
  >
    <b-row
      ><b-col>
        <b-table small :busy="loading" :fields="planFields" striped hover :items="planItems" foot-clone>
          <template #foot()>
            <div></div>
          </template>
          <template #cell(status)="row">
            <b-badge :variant="getStatusColor(row.item.status)">{{ row.item.status }}</b-badge>
          </template>
          <template #foot(client_customer_name)>
            <create-plan
              :id="id + 'programa0'"
              :title="title"
              :market="market"
              :week="week"
              :market-allowed-containers="marketAllowedContainers"
              button
              @refresh="handleShow(true)"
            />
          </template>
          <template #cell(actions)="row">
            <create-plan
              :id="id + 'programa' + row.item.id"
              :title="title"
              :market="market"
              :week="week"
              :data="row.item"
              @refresh="handleShow(true)"
            />
            <create-purchase-order :id="row.item.id" :planData="row.item" @refresh="handleShow(false)">
            </create-purchase-order>
            <b-tooltip :target="'create-op-button' + row.item.id" noninteractive>Crear orden de pedido</b-tooltip>
          </template>
          <template #header(actions)> </template>
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <op-list :items="opItems" :loading="loading" @refresh="handleShow(true)"></op-list>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import CreatePlan from "./CreatePlan.vue";
import OpList from "./OpList.vue";
import CreatePurchaseOrder from "./CreatePurchaseOrder.vue";
export default {
  name: "WeekMarketDetail",
  components: {
    CreatePlan,
    CreatePurchaseOrder,
    OpList
  },
  data() {
    return {
      ready: false,
      loading: false,
      planChanged: false,
      planFields: [
        { key: "client_customer_name", label: "Cliente" },
        { key: "subplan", label: "Programa" },
        { key: "status", label: "Status" },
        { key: "kilograms", label: "Kilos" },
        { key: "ordered_kilograms", label: "Pedido" },
        { key: "actions", label: "", class: "text-right" }
      ],
      planItems: [],
      opItems: []
    };
  },
  props: {
    id: {
      type: String
    },
    title: {
      type: String
    },
    data: {
      type: Object
    },
    market: {
      type: Number
    },
    week: {
      type: String
    },
    marketAllowedContainers: {
      type: Array
    }
  },
  methods: {
    getStatusColor(status) {
      switch (status) {
        case "vigente":
          return "primary";
        case "terminado":
          return "success";
        case "cancelado":
          return "danger";
        default:
          return "secondary";
      }
    },
    handleHide(reload) {
      this.$emit("hide", reload);
    },
    handleShow(planChanged) {
      this.$emit("show");
      if (planChanged) {
        this.planChanged = true;
      }
      this.getWeekMarketPlan().then((data) => {
        this.planItems = data;
        this.loading = false;
      });
      this.getMarketOps().then((data) => {
        this.opItems = data;
        this.loading = false;
      });
    },
    async getWeekMarketPlan() {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/api/comex/plan/?no_page&all&market=${this.market}&week=${this.week}`);
        return response.data;
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    async getMarketOps() {
      this.loading = true;
      try {
        const response = await this.$axios.get(
          `/api/v1/purchase_order/?no_page&plan__market_id=${this.market}&plan__week=${this.week}`
        );
        return response.data;
      } catch (error) {
        console.log(error);
        return [];
      }
    }
  }
};
</script>

<style></style>
